<div class="ngx-modal-header">
    <h4 class="modal-title pull-left">View Report</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <object [data]="embedUrl" type="application/pdf" class="review-report-pdf">
                <embed [src]="reportUrl" type="application/pdf" width="100%" height="500px" />
            </object>
        </div>
    </div>
</div>
